export enum Theme {
  light = 'theme-light',
  dark = 'theme-dark'
}
